module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bg_f5f6f9"
  }), _vm._v(" "), (_vm.channelList.length == 0) ? _c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/img/settings/pic_add.png"),
      "alt": "添加图片"
    }
  }), _vm._v(" "), _c('p', [_vm._v(" 添加频道信息,可以语音换台")]), _vm._v(" "), _c('div', {
    staticClass: "next-btn"
  }, [_c('button', {
    staticClass: "btn-primary",
    on: {
      "click": _vm.gotoAddChannle
    }
  }, [_vm._v("添加频道")])])]) : _c('div', [_c('div', {
    staticClass: "padding-top"
  }, [_c('group', {
    attrs: {
      "title": "自定义频道"
    }
  }, _vm._l((_vm.channelList), function(item) {
    return _c('cell', {
      key: item.customChannelId,
      attrs: {
        "is-link": "",
        "title": item.channelName,
        "value": item.channel
      },
      nativeOn: {
        "click": function($event) {
          _vm.gotoEditChannel(item)
        }
      }
    })
  }))], 1), _vm._v(" "), (_vm.publicChannelList.length) ? _c('div', {
    staticClass: "padding-bottom"
  }, [_c('group', {
    attrs: {
      "title": "通用频道"
    }
  }, _vm._l((_vm.publicChannelList), function(item) {
    return _c('cell', {
      key: item.stbChannelId,
      attrs: {
        "title": item.channelName,
        "value": item.channel
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "add-btn"
  }, [_c('button', {
    staticClass: "btn-operate-positive",
    on: {
      "click": _vm.gotoAddChannle
    }
  }, [_vm._v("添加自定义频道")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b3e4f27"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/channel/ChannelList.vue
// module id = 892
// module chunks = 1